/**
 * @file 全局loading
 * @author sunyingying01
 */

import React from 'react';
import {Spin} from 'antd';
import styles from './index.module.less';

interface FullPageSpinProps {
    tip?: string;
    size?: 'small' | 'default' | 'large';
    height?: string | number;
}

const FullPageSpin: React.FC<FullPageSpinProps> = ({
    tip = '加载中...',
    size = 'large',
    height = '100vh'
}) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height
            }}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                <Spin size={size} />
                {tip && <span className={styles.text}>{tip}</span>}
            </div>
        </div>
    );
};

export default FullPageSpin;
